export default __webpack_public_path__ + "static/media/filled.a7405f05.svg";